import { i18n } from "@/plugins/i18n";
import { TableFieldType, TableHeader } from "helix-vue-components";

export const StateTraceabilityHeaders: TableHeader[] = [
  {
    value: "location.name",
    label: String(i18n.t("location.location")),
    fieldComponent: TableFieldType.string,
    class: "tdt__headers__fieldLong",
    sortable: false
  },
  {
    value: "location.license_number",
    label: String(i18n.t("location.license_number")),
    fieldComponent: TableFieldType.string,
    class: "tdt__headers__fieldLong",
    sortable: false
  },
  {
    value: "location.address1",
    label: String(i18n.t("location.address")),
    fieldComponent: TableFieldType.string,
    class: "tdt__headers__fieldLong",
    sortable: false
  },
  {
    value: "value",
    label: String(i18n.t("state_traceability_system")),
    fieldComponent: TableFieldType.string,
    class: "tdt__headers__fieldLong",
    sortable: false
  },
  {
    value: "config_status",
    label: String(i18n.t("traceability.status")),
    fieldComponent: TableFieldType.string,
    class: "tdt__headers__fieldLong",
    sortable: false,
    conditionalClassFn: item =>
      (item.config && item.config.active && "primary-text") || ""
  }
];
